import React, { useState, useEffect, useContext } from 'react';
import { Button, Row, Col } from 'react-bootstrap';
import { IcoEdit } from '@icons';
import ProjectModal from '@components/projects/ProjectModal';
import { useParams } from 'react-router-dom';
import BreadcrumbsNav from 'components/nav/breadcrumbsNav';
import { submenuTitleMap, tabDescriptionMap, tabTitleMap, tabTitleMapGuestEnteErogante } from 'utils/pageTitleMaps';
import { UserContext } from 'components/contexts/UserProvider';
import { OETrans } from 'components/translation/OETrans';
import EditModal from '@components/projects/EnteEroganteProjectsList/EditModal';

const ProjectHeader = ({ project, setProject, isProjectManager, fetchDataProject, navigationMenu }) => {
	const {
		isOe,
		userAccess: { isExternalAdmin, isGuestEnteErogante },
	} = useContext(UserContext);
	const [thisProject, setThisProject] = useState({});
	const [showModalProject, setShowModalProject] = useState(false);
	const { tab, submenu } = useParams();

	const handleShowModal = (setShowModal) => setShowModal(true);

	useEffect(() => {
		if (project) {
			setThisProject(project);
		}
	}, [project]);

	const headerDescription = {
		fallback: tabDescriptionMap?.[tab]?.[submenu] ?? tabDescriptionMap[tab] ?? '',
		code: `headerdescriptions.${tab}` + (tabDescriptionMap?.[tab]?.[submenu] ? `.${submenu}` : ''),
	};

	const selectedTitleMap = isGuestEnteErogante ? tabTitleMapGuestEnteErogante : tabTitleMap;

	return (
		<>
			<Row className="my-4">
				<Col className="custom-project-header">
					<BreadcrumbsNav />

					<div className="d-flex flex-column mb-4">
						<h1 className="mb-0 fw-bold">{thisProject.name}</h1>

						<div className="d-inline-flex align-items-center flex-wrap mt-1 custom-project-details">
							<span className="p-0 project-details no-pipe">
								{thisProject.cupType === 'I' ? 'ID Progetto: ' : 'CUP: '}
								<span style={{ wordBreak: 'break-all' }}>{thisProject.cup}</span>

								<span className="d-inline-block ms-2">
									{(isOe || isProjectManager || isExternalAdmin) && (
										<Button
											variant="link"
											onClick={() => handleShowModal(setShowModalProject)}
											className="p-0 d-flex align-items-center"
											style={{ lineHeight: 1 }}
										>
											<IcoEdit title={'Modifica Anagrafica'} className="edit" style={{ width: '1rem', height: '1rem' }} />
										</Button>
									)}

									{isGuestEnteErogante && (
										<EditModal
											trigger={
												<Button variant="link" className="p-0 d-flex align-items-center" style={{ lineHeight: 1 }}>
													<IcoEdit title={'Modifica Anagrafica'} className="edit" style={{ width: '1rem', height: '1rem' }} />
												</Button>
											}
											type="edit"
											project={thisProject}
										/>
									)}
								</span>
							</span>
						</div>
					</div>

					{navigationMenu}

					{tab && (
						<div
							style={{
								marginTop: '3rem',
							}}
						>
							<h2 className="mb-2" style={{ fontWeight: 'bold' }}>
								{selectedTitleMap[tab] || ''} {submenuTitleMap[submenu] || ''}
							</h2>
							<h2 style={{ marginBottom: 0, fontSize: '18px', textTransform: 'none', fontWeight: 400, color: '#4A5968' }}>
								<OETrans code={headerDescription.code} fallback={headerDescription.fallback} />
							</h2>
						</div>
					)}
				</Col>
			</Row>

			{/* EDIT PROJECT */}
			{
				<ProjectModal
					showModalProject={showModalProject}
					setShowModalProject={setShowModalProject}
					project={thisProject}
					setProjectHeader={setProject}
					fetchDataProject={fetchDataProject}
				/>
			}
		</>
	);
};
export default ProjectHeader;
